module.exports = __webpack_public_path__ + "static/media/Camada_4.f48a7f3e.svg";